// import APIs
import { getOpenRequests } from 'RestAPIs/roster/open-requests';

// import external libraries
import { useQuery } from 'react-query';

export type GetOpenRequestsProps = {
  costCenters: string;
  startDate: string;
  endDate: string;
};

const useGetOpenRequests = (
  { costCenters, startDate, endDate }: GetOpenRequestsProps,
  options: Record<string, any> = {}
) => {
  const { data, isFetching, isError, refetch } = useQuery(
    ['rosterPlanOpenRequests', costCenters, startDate, endDate],
    async () => {
      const { data } = await getOpenRequests({
        costCenters,
        startDate,
        endDate
      });
      return data;
    },
    options
  );
  return { data, isFetching, isError, refetch };
};

export default useGetOpenRequests;
